import { useState, useEffect } from "react";
import { Moon, Sun } from "lucide-react";

const STORAGE_KEY = "rockfall-theme";

/**
 * Bouton flottant en bas à droite pour basculer entre les modes Nuit et Jour.
 * Sauvegarde le choix dans localStorage et applique l'attribut data-rockfall-theme sur <html>.
 */
export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-rockfall-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // ignore
    }
  }, [theme]);

  return (
    <div className="rk-theme-toggle" data-testid="rk-theme-toggle">
      <button
        type="button"
        className={theme === "dark" ? "active" : ""}
        onClick={() => setTheme("dark")}
        data-testid="rk-theme-night"
        title="Mode nuit"
      >
        <Moon size={14} />
        Nuit
      </button>
      <button
        type="button"
        className={theme === "light" ? "active" : ""}
        onClick={() => setTheme("light")}
        data-testid="rk-theme-day"
        title="Mode jour"
      >
        <Sun size={14} />
        Jour
      </button>
    </div>
  );
}
